module.exports = __webpack_public_path__ + "img/verde.124e005a.png";